/**
 * Top bar component with user menu and logout
 */

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { logout } from '../../services/authService';
import '../../styles/TopBar.css';

const TopBar = ({ onMobileMenuToggle }) => {
  const { user, clearUser } = useAuth();
  const navigate = useNavigate();
  const [showUserMenu, setShowUserMenu] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
      clearUser();
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
      // Still logout locally even if API call fails
      clearUser();
      navigate('/login');
    }
  };

  return (
    <div className="topbar">
      {/* Mobile menu button */}
      <button className="mobile-menu-button" onClick={onMobileMenuToggle}>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
        </svg>
      </button>

      <div className="topbar-content">
        {/* Status Indicator */}
        <div className="status-indicator">
          <div className="status-dot"></div>
          <span>Online</span>
        </div>

        {/* User Menu */}
        <div className="user-menu-container">
          <button 
            className="user-menu-button" 
            onClick={() => setShowUserMenu(!showUserMenu)}
          >
            <div className="user-avatar-small">
              <span>{user?.full_name?.charAt(0) || user?.username?.charAt(0) || 'U'}</span>
            </div>
            <span className="user-name-topbar">{user?.full_name || user?.username}</span>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="chevron-icon">
              <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
            </svg>
          </button>

          {showUserMenu && (
            <>
              <div className="menu-overlay" onClick={() => setShowUserMenu(false)} />
              <div className="user-dropdown">
                <div className="dropdown-header">
                  <p className="dropdown-user-name">{user?.full_name || user?.username}</p>
                  <p className="dropdown-user-email">{user?.email}</p>
                  <p className="dropdown-user-role">{user?.is_admin ? 'Administrator' : 'User'}</p>
                </div>
                <div className="dropdown-divider"></div>
                <button className="dropdown-item" onClick={handleLogout}>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75" />
                  </svg>
                  <span>Logout</span>
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopBar;
